<template>
    <div id="layout">
        <div v-show="working > 0" class="lds-facebook"><div></div><div></div><div></div></div>
        <div id="content">
            <Menu></Menu>
            <div class="page-content">
                <div id="linkList">
                    <ul class="header-ul">
                        <li class="header stoned">
                            <span v-for="(column, key) in table.columns" v-bind:key="key" :class="column[1]">
                                <template v-if="table.sort_key === key">
                                    <a v-show="table.reverse === 1">&#8593;</a>
                                    <a v-show="table.reverse === -1">&#8595;</a>
                                </template>
                                <a v-on:click="nowSort(key)">{{column[0]}}</a>
                            </span>
                        </li>
                        <li class="searchbox">
                            <div class="five">
                                <search-input v-model="search_string"></search-input>&nbsp;
                                <input v-model="from" type="date" id="from"> - <input v-model="to" type="date" id="to">
                                <div v-bind:class="['progress', {'active':progressing}]">
                                    <div class="bar" v-on:transitionend="progressing = false">&nbsp;</div>
                                </div>
                            </div>
                            <div class="one"></div>
                            <div class="one right">Copy all links: <copy-link v-bind:classToSet="'big'" v-bind:text-to-copy="''"></copy-link> Total: <strong>{{filteredLog.length}}</strong> </div>
                        </li>
                    </ul>
                    <ul>
                        <li v-if="working !== 0">
                            <div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
                        </li>
                        <li class="no-data" v-if="filteredLog.length === 0 && working === 0">
                            <h2>NO DATA</h2>
                        </li>
                    </ul>
                    <transition-group name="slide-fade" tag="ul">
                        <access-logs-row v-bind:blink="log_item.blink" v-bind:key="log_item.host + log_item.date + log_item.status + log_item.site" v-for="(log_item, index) in filteredLog" v-bind:order="((index % 2 === 0)?'even':'odd')" v-bind:log_item="log_item"></access-logs-row>
                    </transition-group>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import Storages from 'js-storage'

    import config from '@/config'

    import Menu from '@/components/small/Menu'
    import SearchInput from "@/components/small/SearchInput";
    import CopyLink from "@/components/UI/_base-UI-CopyLink";
    import AccessLogsRow from "@/components/small/AccessLogsRow";


    export default {
        name: "AccessLogs",
        components:{
            AccessLogsRow,
            CopyLink,
            SearchInput,
            Menu
        },
        data: function (){
            return {
                table:{
                    reverse: Storages.localStorage.isSet('AccessLogs:reverse')?Storages.localStorage.get('AccessLogs:reverse'):1,
                    sort_key: Storages.localStorage.isSet('AccessLogs:sort_key')?Storages.localStorage.get('AccessLogs:sort_key'):'date',
                    columns: {
                        'site': ['Site', 'one'],
                        'request' : ['Request', 'two'],
                        'http_referer': ['Ref.URL', 'two'],
                        'date': ['Date', 'one'],
                        'http_user_agent': ['UA', 'two'],
                        'http_status': ['HTTP Code', 'one'],
                    }
                },
                // last_id: 0,
                working: 0,
                progressing: false,
                log: [],
                search_string: Storages.localStorage.isSet('AccessLogs:search_string')?Storages.localStorage.get('AccessLogs:search_string'):'',
                from: Storages.localStorage.isSet('AccessLogs:from')?Storages.localStorage.get('AccessLogs:from'):'',
                to:  Storages.localStorage.isSet('AccessLogs:to')?Storages.localStorage.get('AccessLogs:to'):'',
                filterTimeout: null
            }
        },
        watch:{
            from: function () {
                Storages.localStorage.set('AccessLogs:from', this.from);

                if (this.filterTimeout != null){
                    clearTimeout(this.filterTimeout);
                }

                this.progressing = true;

                this.filterTimeout = setTimeout(()=>{this.getLog()}, 2000);
            },
            to: function () {
                Storages.localStorage.set('AccessLogs:to', this.to);

                this.progressing = true;

                if (this.filterTimeout != null){
                    clearTimeout(this.filterTimeout);
                }
                this.filterTimeout = setTimeout(()=>{this.getLog()}, 2000);
            },
            search_string: function () {
                Storages.localStorage.set('AccessLogs:search_string', this.search_string);

                this.progressing = true;

                if (this.filterTimeout != null){
                    clearTimeout(this.filterTimeout);
                }
                this.filterTimeout = setTimeout(()=>{this.getLog()}, 2000);
            }
        },
        beforeDestroy(){
        },
        mounted: function(){
            this.getLog();
        },
        created: function (){
            this.search_string = Storages.localStorage.isSet('AccessLogs:search_string')?Storages.localStorage.get('AccessLogs:search_string'):'';
            this.from = Storages.localStorage.isSet('AccessLogs:from')?Storages.localStorage.get('AccessLogs:from'):'';
            this.to =  Storages.localStorage.isSet('AccessLogs:to')?Storages.localStorage.get('AccessLogs:to'):'';
        },
        computed: {
            filteredLog: function () {
                 return this.log.sort( (a, b) => {
                    a = a[this.table.sort_key]
                    b = b[this.table.sort_key]
                    return (a === b ? 0 : a > b ? 1 : -1) * this.table.reverse;
                })
            }
        },
        methods: {
            copyAllURLs: function(){
                let all = [];
                console.log(this.log);
                this.filteredLog.forEach(item => {
                    all.push(item.URL)
                });

                copyToClipboard(all.join('\n'));
            },
            copyURL: function(url){
                copyToClipboard(url);
            },
            nowSort: function (new_key){
                if (this.table.sort_key === new_key){
                    this.table.reverse = -1*this.table.reverse;
                }else{
                    this.table.sort_key = new_key;
                    this.table.reverse = 1;
                }
                Storages.localStorage.set('AccessLogs:sort_key', this.table.sort_key);
                Storages.localStorage.set('AccessLogs:reverse', this.table.reverse);
            },
            getLog: async function () {
                this.log = [];
                this.working++;
                let request_url = config.api_url + '/?op=access-logs';

                if(this.from !== ''){
                    request_url += '&from=' + this.from
                }

                if(this.to !== ''){
                    request_url += '&to=' + this.to
                }

                if(this.search_string !== ''){
                    request_url += '&search_string=' + this.search_string
                }

                axios
                    .get(request_url)
                    .then(response => {
                        if (response.data != null) {
                            this.log = response.data;
                        }
                        this.working--;
                    })
                    .catch(error => {
                        console.log(error)
                        this.working--;
                    });
            },
        }
    }
</script>
<style scoped>
    .progress{
        border: 1px solid #444444;
        height: 1rem;
        display: inline-block;
        margin: 0.5rem;
        width: 10rem;
        visibility: hidden;
    }

    .progress.active{
        visibility: visible;
        transition: all 0.3s;
    }

    .bar{
        width: 1%;
        height: 100%;
        background-color: #2b2e71;
    }

    .progress.active .bar{
        width: 100%;
        transition: width 2s;
    }

    #linkList ul li.mygrid {
        display: grid;
        grid-template-columns: 1fr 2fr 2fr 0.5fr 2fr 0.5fr;
        grid-auto-rows: 2rem;
        align-items: baseline;
    }

    #content{
        flex-direction: column;
    }

    ul li a{
        color: #4e4872;
    }

    ul li span{
        width: 100%;
    }

    #linkList #list-wrap{
        max-height: 80%;
    }

    #linkList{
        box-sizing: border-box;
        background: #CCCCCC;
        width: 100%;
        height: 100%;
        border-right: 2px solid #b1b1b1;
        border-top: 2px solid #FFFFFF;
        border-bottom: 2px solid #656565;
        border-left: 2px solid #656565;
        box-shadow: 0px 0px 1px 1px #471932;
        display: flex;
        flex-direction: column;
    }

    #linkList ul li.header{
        text-align: left;
        list-style: none;
        display: grid;
        grid-template-columns: 1fr 2fr 2fr 0.5fr 2fr 0.5fr;
        border-top: 1px solid #b9f1ff;
        border-right: 1px solid #b9f1ff;
        background: #7bc4ff;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to bottom, #7bc4ff, #c7e9ff);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to bottom, #7bc4ff, #c7e9ff); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        padding: 0.5rem;
        color: #FFFFFF;
        text-decoration: underline;
        border-bottom: 1px solid #4d7399;
        border-left: 1px solid #4d7399;
        text-shadow: 1px 1px 0px #888;
    }

    #linkList ul li.header span:first-of-type{
        margin-left: 0.5rem;
    }

    .header span{
        cursor: pointer;
    }

    ul li span:first-of-type{
        margin-left: 0;
    }

    .header span:last-of-type, ul li span:last-of-type{
        margin-right: 0;
    }

    .header p{
        flex: 5 100%;
        margin-top: 0.5rem;
    }

    .header span.two, ul li span.two{
        flex: 2;
    }

    .header span.one, ul li span.one{
        flex: 1;
    }

    ul li{
        list-style: none;
        display: flex;
        flex-wrap: nowrap;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        padding: 0.5rem;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
    }


    ul li.root{
        list-style: none;
        display: flex;
        flex-wrap: nowrap;
        border-top: 1px solid #ffffff;
        border-right: 1px solid #ffffff;
        background: #ffe986;  /* fallback for old browsers */
        padding: 0.5rem;
        color: #000000;
        border-bottom: 1px solid #888;
        border-left: 1px solid #888;
        text-shadow: none;
    }

    ul li.no-data{
        color: #a9a9a9;
        text-align: center;
        text-shadow: 1px 1px 0px #FFF;
    }

    ul li .shadow{
        color: #b9b9b9;
    }

    .lds-ellipsis.small {
        width: 28px;
        height: 28px;
    }

    .lds-ellipsis {
        text-align: center;
        display: block;
        position: relative;
        width: 64px;
        height: 64px;
        margin: auto;
    }

    .lds-ellipsis.small div {
        top: 8px;
        border-radius: 50%;
        background: #93291E;
    }

    .lds-ellipsis div {
        position: absolute;
        top: 27px;
        width: 11px;
        height: 11px;
        border-radius: 50%;
        background: #93291E;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
    }
    .lds-ellipsis div:nth-child(1) {
        left: 6px;
        animation: lds-ellipsis1 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(2) {
        left: 6px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(3) {
        left: 26px;
        animation: lds-ellipsis2 0.6s infinite;
    }
    .lds-ellipsis div:nth-child(4) {
        left: 45px;
        animation: lds-ellipsis3 0.6s infinite;
    }
    @keyframes lds-ellipsis1 {
        0% {
            transform: scale(0);
        }
        100% {
            transform: scale(1);
        }
    }
    @keyframes lds-ellipsis3 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(0);
        }
    }
    @keyframes lds-ellipsis2 {
        0% {
            transform: translate(0, 0);
        }
        100% {
            transform: translate(19px, 0);
        }
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active до версии 2.1.8 */ {
        transform: scaleY(0);
    }
</style>
